import { render, staticRenderFns } from "./GroupReadOnly.vue?vue&type=template&id=06beebf1&"
import script from "./GroupReadOnly.vue?vue&type=script&lang=js&"
export * from "./GroupReadOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06beebf1')) {
      api.createRecord('06beebf1', component.options)
    } else {
      api.reload('06beebf1', component.options)
    }
    module.hot.accept("./GroupReadOnly.vue?vue&type=template&id=06beebf1&", function () {
      api.rerender('06beebf1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/group/GroupReadOnly.vue"
export default component.exports